export default __webpack_public_path__ + "static/media/button-register.min.1de97ef8.svg";